import React from 'react';
import { Check, Camera } from 'lucide-react';

const checks = {
  en: [
    'Pose cards for standing, seated and walking',
    'Styling notes on colour, fabric and length',
    'A beauty check before you release the shutter',
  ],
  de: [
    'Pose-Karten für Stand, Sitz und Gang',
    'Styling-Notizen zu Farbe, Stoff und Länge',
    'Ein Beauty-Check, bevor du auslöst',
  ],
};

export default function FoodScanner({ lang }) {
  const t = {
    label: lang === 'de' ? 'Modelpräsenz' : 'Model presence',
    headline:
      lang === 'de'
        ? 'EIN LOOKBOOK AUS POSE, SCHNITT UND HAUT'
        : 'A LOOKBOOK OF POSE, CUT AND SKIN',
    sub:
      lang === 'de'
        ? 'Du stellst eine Serie zusammen: Stand, Sitz, Gang. Dazu die Beauty-Notiz und das Styling, das du wirklich trägst.'
        : 'You assemble a series: standing, seated, walking. Plus the beauty note and the styling you actually wear.',
    cta: lang === 'de' ? 'LOOKBUCH STARTEN' : 'START THE LOOKBOOK',
  };

  return (
    <section className="bg-[#faf7f4] py-20 lg:py-28 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative flex justify-center">
            <div className="absolute inset-0 -z-10 bg-gradient-to-br from-stone-200/70 to-rose-100/50 rounded-3xl blur-2xl" />
            <img
              src="https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=1200&q=80"
              alt={lang === 'de' ? 'Model im gelben Outfit im Freien' : 'Model in a yellow outfit outdoors'}
              className="w-full max-w-md h-[380px] lg:h-[460px] object-cover rounded-3xl shadow-2xl"
            />

            <div className="absolute top-6 right-4 lg:-right-4 bg-white rounded-2xl px-4 py-3 shadow-xl border border-stone-100 flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-full bg-rose-900 flex items-center justify-center">
                <Camera size={14} color="white" />
              </div>
              <div>
                <p className="text-xs text-stone-400 font-medium leading-none mb-0.5">
                  {lang === 'de' ? 'Serie' : 'Series'}
                </p>
                <p className="text-sm font-bold text-stone-800">Look 04</p>
              </div>
            </div>

            <div className="absolute bottom-6 left-4 lg:-left-4 bg-stone-900 text-white rounded-2xl px-5 py-3 shadow-xl">
              <p className="text-xs font-medium opacity-80 uppercase tracking-wide mb-0.5">
                Editorial
              </p>
              <p className="text-2xl font-black">{lang === 'de' ? 'Bereit' : 'Ready'}</p>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <span className="inline-flex items-center gap-2 w-fit px-4 py-1.5 bg-stone-200 text-stone-800 text-xs font-bold uppercase tracking-widest rounded-full">
              <Camera size={12} />
              {t.label}
            </span>

            <h2 className="text-3xl sm:text-4xl lg:text-4xl xl:text-5xl font-black text-stone-900 tracking-tight leading-tight">
              {t.headline}
            </h2>

            <p className="text-stone-500 text-lg leading-relaxed">{t.sub}</p>

            <ul className="flex flex-col gap-4 mt-2">
              {checks[lang].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-7 h-7 rounded-full bg-stone-900 flex items-center justify-center mt-0.5">
                    <Check size={14} color="white" strokeWidth={3} />
                  </div>
                  <span className="text-stone-700 font-medium leading-snug">{item}</span>
                </li>
              ))}
            </ul>

            <div className="pt-2">
              <a
                href="/s"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-stone-900 hover:bg-rose-950 text-white font-bold rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5"
              >
                <Camera size={18} />
                {t.cta}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
